import { Link } from "react-router-dom";

const TermAndConditions = () => {
  return (
    <>
      <div className=" bg-white overflow-hidden">
        <div className="w-screen h-64 md:h-[430px] border-[3px] border-[#35A93E]">
          <img
            src="/terms.jpeg"
            alt="Terms Banner"
            className="w-full h-full object-contain md:object-contain"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-6">
          <div className="border-b border-gray-200 pb-6 mb-10">
            <h1 className="text-2xl font-bold text-gray-900">
              Terms and Conditions
            </h1>
            <p className="text-sm text-gray-500 mt-4">
              Effective Date: 01.07.2025
            </p>
            <p className="text-sm text-gray-500 mt-2">
              Platform:{" "}
              <a
                href="https://www.lifeonplus.in"
                className="text-blue-600 hover:underline"
              >
                www.lifeonplus.in
              </a>{" "}
              Website & Mobile Application | Contact:{" "}
              <a
                href="mailto:legal@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                legal@lifeonplus.com
              </a>
            </p>
          </div>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              1. Introduction
            </h2>
            <p className="text-base text-gray-700 leading-7">
              Welcome to LifeOnPlus. These Terms & Conditions ("Terms") govern
              your access and use of our platform for purchasing products and
              services, participating as a partner, investor, distributor, or
              network member. By accessing LifeOnPlus, you agree to comply with
              these Terms,{" "}
              <Link
                to="/privacy-policy"
                className="text-blue-600 hover:underline"
              >
                Privacy Policy
              </Link>
              , and other applicable policies.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              2. Definitions
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                <strong>Consumer:</strong> End user who purchases or uses
                products/services on the platform.
              </li>
              <li className="mb-2">
                <strong>Virtual Partner:</strong> Individuals/entities investing
                in LifeOnPlus initiatives.
              </li>
              <li className="mb-2">
                <strong>Channel Partner:</strong> Distributors authorized to
                sell LifeOnPlus offerings.
              </li>
              <li className="mb-2">
                <strong>Network Member:</strong> Individuals part of our
                referral or network marketing program.
              </li>
              <li className="mb-2">
                <strong>Platform:</strong> LifeOnPlus website or app.
              </li>
              <li className="mb-2">
                <strong>Aggregator:</strong> LifeOnPlus acts as a facilitator
                between service/product providers and consumers.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              3. Eligibility & Account Responsibilities
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                You must be at least 18 years of age or have legal capacity to
                enter into agreements.
              </li>
              <li className="mb-2">
                You are responsible for all activities under your account.
              </li>
              <li className="mb-2">
                You agree to provide accurate, complete registration details.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              4. Territorial Jurisdiction & Access Outside India
            </h2>
            <p className="text-base text-gray-700 leading-7">
              The platform and services are intended for use within the Republic
              of India. Users accessing LifeOnPlus from other countries do so at
              their own initiative and are responsible for compliance with local
              laws. LifeOnPlus disclaims responsibility for access, legality, or
              serviceability of its offerings outside India.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              5. Nature of Platform – Aggregator Disclaimer
            </h2>
            <p className="text-base text-gray-700 leading-7">
              LifeOnPlus is a technology aggregator and does not manufacture,
              own, or directly supply third-party products/services unless
              explicitly stated. All content, pricing, availability, and
              warranty are as provided by respective third-party partners or
              service providers. Any dispute arising from such transactions is
              to be resolved with the respective provider, and LifeOnPlus is not
              liable for intermediary issues.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              6. Prescription Medication Policy (Where Applicable)
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Prescription drugs listed on the platform will be sold only upon
                a valid prescription.
              </li>
              <li className="mb-2">
                Users must upload a valid scanned copy of their prescription for
                verification.
              </li>
              <li className="mb-2">
                The platform reserves the right to reject prescriptions that are
                outdated, fake, or incomplete.
              </li>
              <li className="mb-2">
                Products will not be delivered if regulatory criteria are not
                met.
              </li>
              <li className="mb-2">
                The pharmacist/provider has the final authority to fulfill or
                reject the order.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              7. Contract of Sale
            </h2>
            <p className="text-base text-gray-700 leading-7">
              The contract for sale for third-party products/services is solely
              between you and the provider. LifeOnPlus facilitates the order,
              payment processing, and communication, but is not a party to the
              sale unless otherwise indicated. For LifeOnPlus-owned
              products/services, standard consumer rights under Indian law will
              apply.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              8. Indemnification
            </h2>
            <p className="text-base text-gray-700 leading-7">
              You agree to indemnify, defend, and hold harmless LifeOnPlus, its
              directors, officers, affiliates, and employees from:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-7 mt-2">
              <li className="mb-2">
                Any claims, demands, losses, or damages due to your violation of
                these Terms.
              </li>
              <li className="mb-2">
                Any misrepresentation, fraudulent activity, or breach of
                third-party rights.
              </li>
              <li className="mb-2">
                Any dispute arising from your dealings with service providers,
                partners, or network members.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              9. Limitation of Liability
            </h2>
            <p className="text-base text-gray-700 leading-7">
              LifeOnPlus is not liable for any indirect, incidental,
              consequential, or punitive damages arising from platform usage. We
              are not responsible for errors, delays, or failures caused by
              force majeure, third-party actions, or technical limitations. In
              no event will LifeOnPlus's total liability exceed the value of the
              product/service ordered.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              10. Payments, Cancellations & Refunds
            </h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Payment methods include UPI, cards, wallets, and net banking.
              </li>
              <li className="mb-2">
                Refunds are subject to verification and governed by the{" "}
                <Link
                  to="/refund-policy"
                  className="text-blue-600 hover:underline"
                >
                  Refund Policy
                </Link>
                .
              </li>
              <li className="mb-2">
                No refund is applicable for digital products or non-cancellable
                services unless defective or legally mandated.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              11. Partner & Member Specific Terms
            </h2>
            <h3 className="text-xl font-medium text-gray-900 mb-3">
              11.1 Virtual Partners (Investors)
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Governed by specific investment subscription agreements.
              </li>
              <li className="mb-2">
                No equity stake is offered; returns may be structured via
                revenue share models.
              </li>
              <li className="mb-2">
                Exit and payout terms are contractually defined.
              </li>
            </ul>
            <h3 className="text-xl font-medium text-gray-900 mb-3 mt-6">
              11.2 Channel Partners
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Must comply with distributor terms, code of conduct, brand
                standards.
              </li>
              <li className="mb-2">
                Cannot resell unauthorized or counterfeit products/services.
              </li>
            </ul>
            <h3 className="text-xl font-medium text-gray-900 mb-3 mt-6">
              11.3 Network Marketing Members
            </h3>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">
                Must follow marketing ethics and not misrepresent potential
                earnings.
              </li>
              <li className="mb-2">
                Engaging in spamming, coercion, or false promises will result in
                immediate termination.
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              12. Content, Copyrights & IP
            </h2>
            <p className="text-base text-gray-700 leading-7">
              All platform content is owned or licensed by LifeOnPlus.
              Unauthorized reproduction, modification, or distribution is
              strictly prohibited. User-generated content (e.g., testimonials,
              uploads) may be used for marketing after consent.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              13. Suspension & Termination
            </h2>
            <p className="text-base text-gray-700 leading-7">
              We may suspend or terminate any account for violations, fraud, or
              misuse. Pending dues and legal obligations will survive
              termination.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              14. Governing Law & Jurisdiction
            </h2>
            <p className="text-base text-gray-700 leading-7">
              These Terms are governed by Indian law. Disputes will be resolved
              under the jurisdiction of competent courts in Bengaluru,
              Karnataka. Arbitration may be used for contractual disputes where
              applicable.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              15. Amendments
            </h2>
            <p className="text-base text-gray-700 leading-7">
              LifeOnPlus may amend these Terms from time to time. Updated
              versions will be posted on the website/app. Continued use after
              updates implies acceptance.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              16. Contact & Grievance Redressal
            </h2>
            <p className="text-base text-gray-700 leading-7">
              For queries or complaints, contact:
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              <strong>Legal/Grievance Officer</strong>
              <br />
              Email:{" "}
              <a
                href="mailto:legal@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                legal@lifeonplus.com
              </a>
              <br />
              Address: Lifeonplus Technologies India Private Limited, No.301,
              3rd Floor, “Master Mind 1, Royal Palms”, Aarey Milk Colony,
              Goregaon (East), Mumbai-400065
              <br />
              Contact: 📞{" "}
              <a
                href="tel:+919986880000"
                className="text-blue-600 hover:underline"
              >
                99868 80000
              </a>{" "}
              | ✉️{" "}
              <a
                href="mailto:info@lifeonplus.com"
                className="text-blue-600 hover:underline"
              >
                info@lifeonplus.com
              </a>
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              17. User Acknowledgement
            </h2>
            <p className="text-base text-gray-700 leading-7">
              You acknowledge that by accessing and using LifeOnPlus, you have
              read, understood, and agreed to these Terms in full.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermAndConditions;
